import { render } from "./show.vue?vue&type=template&id=ab170bea&scoped=true&ts=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import "./show.vue?vue&type=style&index=0&id=ab170bea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab170bea"]])

export default __exports__